
import React, { useEffect, useState } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import heroImage from '../../assets/about-image.jpeg';
import useDeviceType from '../../utilities/Utility';
import SkillsPage from '../skills-page/SkillsPage';

gsap.registerPlugin(ScrollTrigger);

const AboutPage = React.forwardRef((props, ref) => {
  const isMobile = useDeviceType();
  const [showSkills, setShowSkills] = useState(false); // Stato per gestire la visualizzazione

  useEffect(() => {
    if (!showSkills) {
      // Animazioni per la sezione "ABOUT ME"
      gsap.fromTo('.section-title',
        { opacity: 0, y: -50 },
        { opacity: 1, y: 0, duration: 1, ease: 'power2.out',
          scrollTrigger: {
            trigger: '.section-title',
            start: 'top 80%',
            toggleActions: 'play none none none'
          }
        }
      );

      gsap.fromTo('.name-title, .subtitle',
        { opacity: 0, y: 50 },
        { opacity: 1, y: 0, duration: 1, ease: 'power2.out',
          stagger: 0.3,
          scrollTrigger: {
            trigger: '.name-title, .subtitle',
            start: 'top 80%',
            toggleActions: 'play none none none'
          }
        }
      );

      gsap.fromTo('.description',
        { opacity: 0, y: 30 },
        { opacity: 1, y: 0, duration: 1, ease: 'power2.out',
          scrollTrigger: {
            trigger: '.description',
            start: 'top 80%',
            toggleActions: 'play none none none'
          }
        }
      );
    } else {
      // Animazioni per la sezione "SKILLS"
      gsap.fromTo('.skills-title',
        { opacity: 0, y: -50 },
        { opacity: 1, y: 0, duration: 1, ease: 'power2.out',
          scrollTrigger: {
            trigger: '.skills-title',
            start: 'top 80%',
            toggleActions: 'play none none none'
          }
        }
      );

      gsap.fromTo('.name-title, .subtitle',
        { opacity: 0, y: 50 },
        { opacity: 1, y: 0, duration: 1, ease: 'power2.out',
          stagger: 0.3,
          scrollTrigger: {
            trigger: '.name-title, .subtitle',
            start: 'top 80%',
            toggleActions: 'play none none none'
          }
        }
      );
    }
      gsap.fromTo('.button-primary',
        { opacity: 0, y: 50 },
        { opacity: 1, y: 0, duration: 0.1, ease: 'power2.out',
          stagger: 0.3,
          scrollTrigger: {
            trigger: '.button-primary',
            toggleActions: 'play none none none'
          }
        }
      );

    // Animazione per il componente attuale (descrizione o skills)
    const animationClass = showSkills ? '.skills-content' : '.description-content';
    gsap.fromTo(animationClass,
      { opacity: 0 },
      { opacity: 1, duration: 1 }
    );
  }, [showSkills]);

  useEffect(() => {
    const fromVars = isMobile
      ? { opacity: 0, scale: 1 }
      : { opacity: 0, scale: 1.2 };

    const toVars = {
      display: 'block',
      opacity: 1,
      scale: 1,
      duration: 1,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: '.hero',
        start: 'top 80%',
        toggleActions: 'play none none none'
      }
    };

    gsap.fromTo('.hero', fromVars, toVars);
  }, [isMobile]);

  const handleToggleClick = () => {
    const currentContent = showSkills ? '.skills-content' : '.description-content';
    gsap.to(currentContent, {
      opacity: 0,
      duration: 0.5,
      onComplete: () => setShowSkills(!showSkills),
    });
  };

  return (
    <div ref={ref} className='container-fluid bg-light p-md-0 py-5 m-0 position-relative'>
      <h1 className={`section-title ms-md-5 ms-1 text-break ${showSkills ? 'skills-title' : ''}`}>
        {showSkills ? 'SKILLS' : 'ABOUT ME'}
      </h1>
      <div className="container text-center pt-2 z-index-major">
        <div className="row flex-row-reverse min-height-100-y align-items-center justify-content-center">
          <div className="col-md-6 flex-column text-start ps-md-5">
            <div style={{ lineHeight: '10px' }}>
              <h2 className='name-title p-0 m-0 fs-1 fw-bolder'>{!showSkills ? 'Mario Di Stefano' : 'My skills'}</h2>
              <div className='subtitle'>
                {!showSkills ? (
                  <p className='profession text-secondary'>front-end developer</p>
                ) : (
                  <p className='profession text-secondary' >Technologies, Frameworks, and Libraries I Frequently Use</p>
                )}
              </div>
            </div>

            {showSkills ? (
              <div className="skills-content">
                <SkillsPage />
              </div>
            ) : (
              <div className="description-content">
                <p className='description m-0'>
                  I’m a young web developer with about 2 years of experience in programming, based in Catania, Sicily. I’m a full-time programmer with a strong focus on design and web development. I like to describe myself as an “explorer” because I love traveling and discovering new things. This curiosity extends to my professional life as well, where I enjoy exploring and learning new libraries and technologies to stay ahead of the curve!
                </p>
              </div>
            )}
          <div className='d-flex justify-content-start '>
            <button onClick={handleToggleClick} className='btn rounded-5 border fw-bolder mt-3  button-primary show-skill-about-button'>
              {showSkills ? 'About Me' : 'My skills'}
            </button>
          </div>
       
          </div>

          <div className="col-lg-4 col-md-6 d-flex justify-content-center p-md-0 px-5">
            <img className="hero rounded-5 mt-5" src={heroImage} alt="mario's image" />
          </div>
        </div>
      </div>
    </div>
  );
});

export default AboutPage;    